import React from 'react'
import {useIntl} from 'react-intl'
import {DEFAULT_DATE_FILTER, MOBILE_MAX_WIDTH, TABLET_BREAKPOINT} from '../../../../_gori/constants'
import {DatePicker} from '../../../../_gori/helpers/components/DatePicker'
import {InputSearch, TableHeader} from '../../../../_gori/partials/widgets'
import {UploadUspsClaimsAgreementModal} from '../modals/UploadUspsClaimsAgreementModal'
import UseRoutesPermission from '../../../../_gori/hooks/UseRoutesPermission'
import {TrackingNumberClaimModal} from '../modals/TrackingNumberClaimsModal'
import {KTSVG} from '../../../../_gori/helpers'
import clsx from 'clsx'
import useWindowDimensions from '../../../../_gori/hooks/useWindowDimensions'

type Props = {
  reloadTable?: any
  isLoadingExport?: any
  handleExport?: any
  showTrackingNumberClaimModal?: any
  setShowTrackingNumberClaimModal?: any
  showModalUploadUspsClaim?: any
  setShowModalUploadUspsClaim?: any
}

const ClaimsFilter: React.FC<Props> = ({
  reloadTable,
  isLoadingExport,
  handleExport,
  showTrackingNumberClaimModal,
  setShowTrackingNumberClaimModal,
  showModalUploadUspsClaim,
  setShowModalUploadUspsClaim,
}) => {
  const intl = useIntl()
  const {routes} = UseRoutesPermission()
  const {width} = useWindowDimensions()

  return (
    <>
      {routes.CLAIMS_CREATE.hasPermission && showTrackingNumberClaimModal && (
        <TrackingNumberClaimModal
          show={showTrackingNumberClaimModal}
          setShow={setShowTrackingNumberClaimModal}
          onCreateClaimsSuccessCallback={reloadTable}
        />
      )}
      <UploadUspsClaimsAgreementModal
        show={showModalUploadUspsClaim}
        handleClose={() => {
          setShowModalUploadUspsClaim(false)
        }}
        reloadTable={() => reloadTable()}
      />
      <TableHeader className='min-h-1px my-5 mb-8'>
        <div
          className={clsx('card-title align-items-start filter-toolbar-44', {
            'w-100': width < TABLET_BREAKPOINT,
          })}
        >
          <div className='d-flex align-items-start position-relative w-100'>
            <InputSearch placeholder={intl.formatMessage({id: 'TRACKING_NUMBER'})} />
          </div>
        </div>
        <div
          className={clsx(
            'card-toolbar flex-row-fluid justify-content-end gap-3 align-items-start filter-toolbar-44',
            {
              'w-100': width < TABLET_BREAKPOINT,
            }
          )}
        >
          <div
            className={clsx({
              'col-8': width < TABLET_BREAKPOINT,
              'col-12': width <= MOBILE_MAX_WIDTH,
            })}
          >
            <DatePicker
              className={clsx('bg-input-dark', {
                'col-12': width <= MOBILE_MAX_WIDTH,
              })}
              name={intl.formatMessage({id: 'REQUEST_DATE'})}
              dateStart={DEFAULT_DATE_FILTER.CLAIMS}
              justifyContent='start'
            />
          </div>
          <div
            className={clsx('btn bg-input-dark fw-bolder align-content-center', {
              'flex-1': width < TABLET_BREAKPOINT,
              'col-12': width <= MOBILE_MAX_WIDTH,
            })}
            onClick={() => handleExport()}
          >
            <KTSVG path='/media/gori/account/download.svg' className='svg-icon-2' />
            {intl.formatMessage({id: 'EXPORT_CLAIM_LIST'})}
            {isLoadingExport && (
              <div className='ms-2 spinner-border spinner-border-sm' role='status' />
            )}
          </div>
        </div>
      </TableHeader>
    </>
  )
}

export {ClaimsFilter}
